import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { useContext } from "react";
import CustomButton from "../CustomButton";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import * as gtag from "@/app/utils/gtag";

const SingleCardContent = ({
	data,
	facility,
	setMasterplanSelectedUnit,
	setActiveUnitCard,
	insideAmenitiesDetailsPage
}: {
	data?: any;
	facility?: boolean;
	setMasterplanSelectedUnit?: React.Dispatch<React.SetStateAction<any>>;
	setActiveUnitCard?: React.Dispatch<React.SetStateAction<boolean>>;
	insideAmenitiesDetailsPage?: boolean
}) => {
	const { isIpad, isMobile } = useContext(screenSizeContext);
	gsap.registerPlugin(ScrollToPlugin);
	
	return (
		<div className="col1 flex flex-col w-[100%] lg:w-[60%] h-full min-h-0 justify-between gap-4 lg:gap-6">
			<div className="flex flex-col gap-3 min-h-0 flex-1 overflow-hidden">
				{isIpad || isMobile ? (
					<div className="flex flex-row justify-between items-center shrink-0">
						<div className="Unit name text-h6 ">
							{facility ? data?.title.en : data?.name?.en}
						</div>
						{!facility && data?.unit_condition === "sold_out" && (
							<div className="label flex justify-center items-center text-labelS rounded-[3rem] bg-oBlack-10 w-fit h-fit p-2 uppercase tracking-[2px] font-semibold">
								{data?.unit_condition?.replace(/_/g, "")}
							</div>
						)}
					</div>
				) : (
					<div className="flex flex-col gap-3 shrink-0">
						{!facility && data?.unit_condition === "sold_out" && (
							<div className="label text-labelS rounded-[3rem] bg-oBlack-10 w-fit p-2 uppercase tracking-[2px] font-semibold	">
								{data?.unit_condition?.replace(/_/g, " ")}
							</div>
						)}
						<div className="Unit name text-h6 ">
							{facility ? data?.title.en : data?.name?.en}
						</div>
					</div>
				)}
				{!isIpad && (
					<p className="text-bodyM font-national text-oBlack-60 min-h-0 flex-1 overflow-y-auto overscroll-contain pr-1">
						{facility ? data?.description?.en : data?.short_description?.en}
					</p>
				)}
			</div>
			{!facility && !isIpad && (
				<div className={`flex-shrink-0 pt-2 ${insideAmenitiesDetailsPage && "hidden"}`}>
					<CustomButton
						text={"Buy now"}
						action={() => {
							gtag.conversion('s22iCL--jN8bELy50MNC');
							const getInTouchSection = document.getElementById("get_in_touch");

							if (getInTouchSection) {
								gsap.to(window, {
									duration: 1,
									scrollTo: getInTouchSection as any,
								});
								if (setMasterplanSelectedUnit && setActiveUnitCard) {
									setActiveUnitCard(false);
									setMasterplanSelectedUnit(data?.id);
								}
							}
						}}
						hasIcon
						style="blue"
						customClass="flex-1 w-fit "
						url={""}
					/>
				</div>
			)}
		</div>
	);
};

export default SingleCardContent;
